export const GET_GROUPERS_SURVEY="GET_GROUPERS_SURVEY";
export const DELETE_GROUPER_SURVEY="DELETE_GROUPER_SURVEY";
export const GET_TREE_GROUPERS_SURVEY="GET_TREE_GROUPERS_SURVEY";
